module.exports = __webpack_public_path__ + "static/media/images_section_img4.7558a494.png";